<script lang="ts">
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import FallbackResult from '@tilelist/components/tile-list-page/FallbackResult.svelte';
    import FallbackResultE3933 from '@tilelist/layouts/experiments/e3933/fallback-result/FallbackResult.svelte';

    interface Props {
        children?: import('svelte').Snippet;
    }

    let { children }: Props = $props();

    const onex = injectWiring().onex;
    const visualRefreshActive = $derived(onex.isExperimentGroup('VISUAL_REFRESH', 'E3933B'));
</script>

{#if visualRefreshActive}
    <FallbackResultE3933>
        {@render children?.()}
    </FallbackResultE3933>
{:else}
    <FallbackResult>
        {@render children?.()}
    </FallbackResult>
{/if}
